import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CrmRouteView from './pages/CrmRouteView.vue';

const DealBoardPage = () => import('./pages/DealBoardPage.vue');
const DealDetailPage = () => import('./pages/DealDetailPage.vue');
const DealListPage = () => import('./pages/DealListPage.vue');
const FunnelsPage = () => import('./pages/FunnelsPage.vue');
const FunnelEditorPage = () => import('./pages/FunnelEditorPage.vue');
const ProductsPage = () => import('./pages/ProductsPage.vue');
const ProductEditorPage = () => import('./pages/ProductEditorPage.vue');
const CrmSettingsPage = () => import('./pages/CrmSettingsPage.vue');
const TicketBoardPage = () => import('./pages/TicketBoardPage.vue');
const TicketListPage = () => import('./pages/TicketListPage.vue');
const TicketDetailPage = () => import('./pages/TicketDetailPage.vue');
const TasksPage = () => import('./pages/TasksPage.vue');
const DealCalendarPage = () => import('./pages/DealCalendarPage.vue');
const TicketCalendarPage = () => import('./pages/TicketCalendarPage.vue');

// Deal pages: visible to admin, agent, or users with deal_view_all/deal_view_own
const dealMeta = {
  permissions: ['administrator', 'agent', 'deal_view_all', 'deal_view_own'],
};

// Ticket pages: visible to admin, agent, or users with ticket_view_all/ticket_view_own
const ticketMeta = {
  permissions: ['administrator', 'agent', 'ticket_view_all', 'ticket_view_own'],
};

// Task pages: visible to admin, agent, or users with task_view_all/task_view_own
const taskMeta = {
  permissions: ['administrator', 'agent', 'task_view_all', 'task_view_own'],
};

const crmRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/crm'),
      component: CrmRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'crm_board', params: to.params };
          },
        },
        {
          path: 'board',
          name: 'crm_board',
          meta: dealMeta,
          component: DealBoardPage,
        },
        {
          path: 'board/:itemId',
          name: 'crm_item_detail',
          meta: dealMeta,
          component: DealDetailPage,
          props: true,
        },
        {
          path: 'list',
          name: 'crm_list',
          meta: dealMeta,
          component: DealListPage,
        },
        {
          path: 'calendar',
          name: 'crm_calendar',
          meta: dealMeta,
          component: DealCalendarPage,
        },
        {
          path: 'funnels',
          name: 'crm_funnels',
          meta: {
            permissions: ['administrator', 'pipeline_view'],
          },
          component: FunnelsPage,
        },
        {
          path: 'funnels/new',
          name: 'crm_funnel_new',
          meta: {
            permissions: ['administrator', 'pipeline_create'],
          },
          component: FunnelEditorPage,
        },
        {
          path: 'funnels/:funnelId/edit',
          name: 'crm_funnel_edit',
          meta: {
            permissions: ['administrator', 'pipeline_edit'],
          },
          component: FunnelEditorPage,
          props: true,
        },
        {
          path: 'products',
          name: 'crm_products',
          meta: {
            permissions: ['administrator', 'agent', 'product_view'],
          },
          component: ProductsPage,
        },
        {
          path: 'products/new',
          name: 'crm_product_new',
          meta: {
            permissions: ['administrator', 'product_create'],
          },
          component: ProductEditorPage,
        },
        {
          path: 'products/:productId/edit',
          name: 'crm_product_edit',
          meta: {
            permissions: ['administrator', 'product_edit'],
          },
          component: ProductEditorPage,
          props: true,
        },
        {
          path: 'tickets',
          name: 'crm_tickets_board',
          meta: ticketMeta,
          component: TicketBoardPage,
        },
        {
          path: 'tickets/list',
          name: 'crm_tickets_list',
          meta: ticketMeta,
          component: TicketListPage,
        },
        {
          path: 'tickets/calendar',
          name: 'crm_tickets_calendar',
          meta: ticketMeta,
          component: TicketCalendarPage,
        },
        {
          path: 'tickets/:ticketId',
          name: 'crm_ticket_detail',
          meta: ticketMeta,
          component: TicketDetailPage,
          props: true,
        },
        {
          path: 'tasks',
          name: 'crm_tasks',
          meta: taskMeta,
          component: TasksPage,
        },
        {
          path: 'settings',
          name: 'crm_settings',
          meta: {
            permissions: ['administrator', 'settings_manage_account'],
          },
          component: CrmSettingsPage,
        },
      ],
    },
  ],
};

export default crmRoutes;
